// hook/ShowTable/generic.ts
import { useEffect, useMemo, useState, useCallback } from 'react';
import { fetchResource } from '../request';

export function useIteamResource<T>(
  path?: string,
  params?: Record<string, any>,
  enabled: boolean = true
) {
  const [data, setData] = useState<T | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<unknown>(null);

  const depsKey = useMemo(() => JSON.stringify(params ?? {}), [params]);

  const load = useCallback(async () => {
    if (!enabled || !path) return;
    try {
      setLoading(true);
      setError(null);
      const out = await fetchResource<T>(path, params);
      setData(out);
    } catch (e) {
      setError(e);
    } finally {
      setLoading(false);
    }
  }, [path, depsKey, enabled]);

  useEffect(() => {
    if (!enabled || !path) return;
    load();
  }, [load, enabled, path]);

  return { data, loading, error, refetch: load };
}
